import { useContext } from "react";
import { LangContext } from "../../context/LangContext";
import { Link } from "react-router-dom";
import Awards from "../Awards";
import "./style.css"

import lines_icon from '../../assets/svg/lines.svg';
import useViewport from "../../hooks/useViewport";

function Onglet({ to, serie, line }) {
    const { isDesktop } = useViewport();
    const { language, translations } = useContext(LangContext);

    const formatURL = isDesktop ? 'url' : '_url';
    const imageURL = isDesktop && line && serie.mini ? serie.mini[formatURL] : serie.images[0][formatURL];

    return (
        <li className='onglet'>
            <Link to={`/${language}/${to}`}>
                <div className="preview">
                    <i className="img" style={{ backgroundImage: `url('${imageURL}')` }} />
                    <p className="hover">-<span>{translations.view}</span>-</p>
                </div>

                <div className="descrip">
                    <h3>-<span>{serie.title}</span>-</h3>
                    {line && <img className="line" src={lines_icon} alt="" loading="lazy" />}

                    <p><span>{translations.genre} :</span>{serie.genre}</p>
                    <p><span>{translations.theme} :</span>{serie[`theme_${language}`]}</p>

                    {serie[`awards_${language}`].length !== 0 && <Awards serie={serie} />}
                </div>
            </Link>
        </li>
    )
}

export default Onglet;